var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 9,
    viewBox: "0 0 12 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6732 0.182992C11.7903 0.300196 11.8562 0.459139 11.8562 0.624866C11.8562 0.790594 11.7903 0.949537 11.6732 1.06674L4.64691 8.09362C4.58307 8.15749 4.50726 8.20816 4.42383 8.24273C4.3404 8.2773 4.25097 8.29509 4.16066 8.29509C4.07035 8.29509 3.98092 8.2773 3.89749 8.24273C3.81406 8.20816 3.73825 8.15749 3.67441 8.09362L0.18316 4.60237C0.125091 4.5443 0.0790284 4.47536 0.0476018 4.39949C0.0161751 4.32362 6.11855e-10 4.2423 0 4.16018C-6.11855e-10 4.07806 0.0161751 3.99674 0.0476018 3.92087C0.0790284 3.845 0.125091 3.77606 0.18316 3.71799C0.241229 3.65992 0.310167 3.61386 0.386037 3.58243C0.461908 3.55101 0.543226 3.53483 0.625348 3.53483C0.707469 3.53483 0.788787 3.55101 0.864658 3.58243C0.940528 3.61386 1.00947 3.65992 1.06754 3.71799L4.16129 6.81174L10.7888 0.182992C10.906 0.0658222 11.0649 0 11.2307 0C11.3964 0 11.556 0.0658222 11.6732 0.182992Z",
    fill: "#262F5F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.516af0d2fe236b92bdd5c1ab8045e693.svg";
export { ForwardRef as ReactComponent };